import AppLayout from '../views/layouts/AppLayout'

export default [
  {
    path: '/settings/groups',
    name: 'settings.groups.index',
    component: () => import(/* webpackChunkName: "settings_groups_index" */ '../views/settings/groups/Index.vue'),
    meta: {
      layout: AppLayout,
      pageTitle: 'หน่วยงาน',
      bodyClass: 'app-page',
      title: 'หน่วยงาน'
    }
  },
  {
    path: '/settings/groups/create',
    name: 'settings.groups.create',
    component: () => import(/* webpackChunkName: "settings_groups_create" */ '../views/settings/groups/Create.vue'),
    meta: {
      layout: AppLayout,
      pageTitle: 'สร้างหน่วยงาน',
      bodyClass: 'app-page',
      title: 'สร้างหน่วยงาน'
    }
  },
  {
    path: '/settings/groups/:id',
    name: 'settings.groups.show',
    component: () => import(/* webpackChunkName: "settings_groups_show" */ '../views/settings/groups/Show.vue'),
    meta: {
      layout: AppLayout,
      pageTitle: 'หน่วยงาน',
      bodyClass: 'app-page',
      title: 'หน่วยงาน'
    }
  },
  {
    path: '/settings/groups/:id/edit',
    name: 'settings.groups.edit',
    component: () => import(/* webpackChunkName: "settings_groups_edit" */ '../views/settings/groups/Edit.vue'),
    meta: {
      layout: AppLayout,
      pageTitle: 'แก้ไขหน่วยงาน',
      bodyClass: 'app-page',
      title: 'แก้ไขหน่วยงาน'
    }
  }
]
